import type { PrimeVuePTOptions } from 'primevue/config';

import { cx } from '@/helpers/cva';

export default {
  root: ({ instance, props }) => ({
    class: cx([
      'py-[10px] px-[17.5px] rounded-[6px]',
      {
        'v3-btn': [null, 'secondary', 'primary', 'info', 'help', 'tertiary', 'orange'].includes(props?.severity ?? null),
        'opacity-50': props?.disabled,
        'border-[--v3-button-dangerbuttonborder]': props?.severity === 'danger',
        'bg-[--v3-button-dangerbuttonbg] text-[--v3-button-dangerbuttontextcolor] hover:bg-[--v3-button-dangerbuttonhoverbg] hover:text-[--v3-button-dangerbuttontexthovercolor]': props?.severity === 'danger' && !props?.outlined,
        'bg-transparent text-[--v3-button-dangerbuttonbg] hover:bg-[--v3-button-dangerbuttonbg-4]': props?.severity === 'danger' && props?.outlined,
      },
    ], instance?.$attrs?.class),
  }),
  label: {
    class: ['v3-h6-bold-700-line-height-1.2'],
  },
} satisfies PrimeVuePTOptions['button'];
